import { render, staticRenderFns } from "./ReportPromoSAGlobal.vue?vue&type=template&id=06cd4106"
import script from "./ReportPromoSAGlobal.vue?vue&type=script&lang=js"
export * from "./ReportPromoSAGlobal.vue?vue&type=script&lang=js"
import style0 from "./ReportPromoSAGlobal.vue?vue&type=style&index=0&id=06cd4106&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports